import type { CycleOutcome } from "../../cycles/hooks/useCycles";
import type {
  CyclePregnancyStatusRecord,
  PatientPregnancyStands,
} from "./useCyclePregnancyStatus";

export type LegacyPregnancyOutcome = Partial<
  Pick<
    CycleOutcome,
    "pregnancyOutcome" | "miscarriageOutcome" | "liveBirthCount"
  >
>;
export type PregnancyStatusReading =
  CyclePregnancyStatusRecord | "unknown" | null;

/** Patient statements take precedence; older intake/import records remain readable. */
export function resolvePregnancyStands(
  outcome: LegacyPregnancyOutcome | null | undefined,
  patientStands: PatientPregnancyStands | "unknown" | null | undefined,
): PatientPregnancyStands | "unknown" | null {
  if (patientStands != null) return patientStands;
  if (outcome?.miscarriageOutcome) return "ended";
  if (
    outcome?.pregnancyOutcome === "live_birth" ||
    outcome?.pregnancyOutcome === "multiple_live_birth"
  ) {
    return "birth";
  }
  return null;
}
